<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Notificação
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                :value="content.assunto"
                label="Assunto da Notificação"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-textarea
                :value="content.descricao"
                label="Notificação*"
                readonly
                outlined
                dense
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="12">
              <v-text-field
                :value="content.dataNotificacao"
                label="Data da Notificação"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" outline @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import {NotificacaoUsuario} from "commons/classes/notificacao-usuario";

export default {
  props: new DialogProps(NotificacaoUsuario),
};
</script>